export default __webpack_public_path__ + "static/media/chatImage.10edf7a5.svg";